<div class="confirmation-container">
	<div class="card-header">
		<mat-icon class="large-icon success-color">check_circle</mat-icon>
		<h3 class="f-h3 success-title">{{ 'REQUEST_SUBMITTED_TITLE' | translate }}</h3>
	</div>

	<div class="confirmation-details" *ngIf="!isWizardSubmit">
		<h4 class="f-h4">{{ 'CASE_NUMBER_LABEL' | translate }}</h4>
		<div class="case-number" [attr.aria-label]="'Case number: ' + requestId">
			{{ requestId }}
		</div>
	</div>
	<div class="confirmation-details" *ngIf="isWizardSubmit">
		<p class="f-body">{{ 'CASE_NUMBER_EMAIL_NOTE' | translate }}</p>
	</div>

	<div class="confirmation-message">
		<p class="f-body">{{ 'REQUEST_CONFIRMATION_MESSAGE' | translate }}</p>
		<p class="f-body-s secondary-message">{{ 'EMAIL_UPDATES_MESSAGE' | translate }}</p>
	</div>

	<div class="next-steps">
		<h4 class="f-h4">{{ 'WHAT_HAPPENS_NEXT' | translate }}</h4>
		<ol>
			<li>{{ 'NEXT_STEP_1' | translate }}</li>
			<li>{{ 'NEXT_STEP_2' | translate }}</li>
			<li>{{ 'NEXT_STEP_3' | translate }}</li>
		</ol>
	</div>

	<div class="form-actions">
		<button mat-raised-button
						color="primary"
						(click)="goToLogin()"
						class="action-button">
			{{ 'RETURN_TO_LOGIN' | translate }}
		</button>

		<button mat-button
						(click)="printConfirmation()"
						class="action-button secondary">
			{{ 'PRINT_CONFIRMATION' | translate }}
		</button>
	</div>
</div>